(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-rotator')) {
    class AnnouncementRotator extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.announcement-bar__item'));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pauseButton = this.querySelector('.announcement-bar__pause');
        if (this.items.length < 2 || reducedMotion) {
          this.pauseButton?.remove();
          return;
        }
        this.index = 0;
        this.start();
        this.pauseButton?.addEventListener('click', () => {
          const paused = this.pauseButton.getAttribute('aria-pressed') === 'true';
          this.pauseButton.setAttribute('aria-pressed', String(!paused));
          this.pauseButton.setAttribute(
            'aria-label',
            paused ? this.pauseButton.dataset.pauseLabel : this.pauseButton.dataset.playLabel
          );
          paused ? this.start() : this.stop();
        });
      }

      start() {
        this.timer = setInterval(() => {
          this.items[this.index].classList.remove('is-active');
          this.index = (this.index + 1) % this.items.length;
          this.items[this.index].classList.add('is-active');
        }, 5000);
      }

      stop() {
        clearInterval(this.timer);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }
    }
    customElements.define('announcement-rotator', AnnouncementRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  if (!customElements.get('cart-page')) {
    class CartPage extends HTMLElement {
      connectedCallback() {
        // last-write-wins: stale responses are dropped
        this.requestId = 0;
        this.sectionId = this.closest('.shopify-section').id.replace('shopify-section-', '');

        this.addEventListener('change', (event) => {
          if (!event.target.matches('.quantity-input__field')) return;
          const line = event.target.closest('[data-line-item]');
          if (line) this.change(line.dataset.lineItem, Number(event.target.value), line);
        });

        this.addEventListener('click', (event) => {
          const remove = event.target.closest('[data-line-remove]');
          if (!remove) return;
          event.preventDefault();
          this.change(remove.dataset.lineRemove, 0, remove.closest('[data-line-item]'));
        });
      }

      async change(key, quantity, lineElement) {
        const requestId = ++this.requestId;
        lineElement?.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity, sections: [this.sectionId] }),
          });
          const data = await response.json();
          if (requestId !== this.requestId) return;
          if (!response.ok) {
            lineElement?.removeAttribute('aria-busy');
            this.showError(data.description || data.message);
            return;
          }
          this.render(data.sections[this.sectionId]);
        } catch {
          lineElement?.removeAttribute('aria-busy');
          this.showError();
        }
      }

      render(sectionHtml) {
        if (!sectionHtml) return;
        const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const next = parsed.querySelector('cart-page');
        if (!next) return;
        this.innerHTML = next.innerHTML;
        this.dataset.itemCount = next.dataset.itemCount;
        this.syncBadge();
      }

      syncBadge() {
        const count = Number(this.dataset.itemCount || 0);
        const cartLink = document.querySelector('.header__cart');
        if (!cartLink) return;
        let badge = cartLink.querySelector('.header__cart-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'header__cart-count';
            badge.setAttribute('aria-hidden', 'true');
            cartLink.appendChild(badge);
          }
          badge.textContent = count;
        } else {
          badge?.remove();
        }
      }

      showError(message) {
        const errorElement = this.querySelector('[data-cart-error]');
        if (!errorElement) return;
        errorElement.textContent = message || this.dataset.errorFallback;
        errorElement.hidden = false;
      }
    }
    customElements.define('cart-page', CartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!customElements.get('facets-form')) {
    class FacetsForm extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-facets-close]')) {
            event.target.closest('details')?.removeAttribute('open');
            return;
          }
          // a click on the drawer's ::before overlay targets the <details>
          // element itself (never the summary or the panel): close it
          if (event.target.matches('.collection__facets-drawer')) {
            event.target.removeAttribute('open');
          }
        });
      }
    }
    customElements.define('facets-form', FacetsForm);
  }

  if (!customElements.get('collection-sort')) {
    class CollectionSort extends HTMLElement {
      connectedCallback() {
        this.querySelector('select').addEventListener('change', (event) => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', event.target.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      }
    }
    customElements.define('collection-sort', CollectionSort);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Footer menus read as columns from 750px up and as collapsed rows below it,
  // so the footer stays short on a phone. The markup ships open: without this
  // script every menu simply stays expanded.
  if (!customElements.get('footer-menus')) {
    class FooterMenus extends HTMLElement {
      connectedCallback() {
        // matchMedia covers both continuous resizing and browser zoom, which
        // changes the viewport width in CSS pixels
        this.desktop = window.matchMedia('screen and (min-width: 750px)');
        this.sync = this.sync.bind(this);
        this.desktop.addEventListener('change', this.sync);
        this.sync();
      }

      disconnectedCallback() {
        this.desktop?.removeEventListener('change', this.sync);
      }

      sync() {
        const isDesktop = this.desktop.matches;
        this.querySelectorAll('.footer__menu-details').forEach((row) => {
          row.open = isDesktop;
          const toggle = row.querySelector('summary');
          // from 750px up the summary is a heading, not a control
          if (toggle) toggle.tabIndex = isDesktop ? -1 : 0;
        });
      }
    }

    customElements.define('footer-menus', FooterMenus);
  }

  document.querySelectorAll('.footer__locale').forEach((details) => {
    details.addEventListener('click', (event) => {
      // the ::before scrim belongs to the details box itself
      if (event.target === details || event.target.closest('[data-locale-close]')) {
        details.open = false;
      }
    });
    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') details.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  /**
   * Author pictures are the one part of a review that is not already in the
   * HTML: they come from Google's own CDN, one request each. `loading="lazy"`
   * was not enough on its own, because the slides sitting off to the side of a
   * carousel still fall inside the margin the browser preloads within, so all
   * ten fired on load. The markup ships them as `data-src` instead and this
   * hands over the real URL only when the card gets close, which on a product
   * page usually means never.
   *
   * Until one lands the project skeleton shimmers over the monogram; when it
   * lands the skeleton stops; when it never lands (rotated URL, content
   * blocker, offline) the picture is taken out and the monogram is what stays.
   * All three states are CSS, this only sets which.
   */
  (() => {
    const settle = (avatar) => {
      const photo = avatar.querySelector('.review-card__photo');
      if (!photo) return;

      // a cached or already-sourced image can be done before we get here, and
      // then neither event would ever fire
      if (photo.complete && photo.currentSrc) {
        avatar.dataset.reviewAvatar = photo.naturalWidth > 0 ? 'ready' : 'failed';
        return;
      }

      photo.addEventListener('load', () => {
        avatar.dataset.reviewAvatar = 'ready';
      }, { once: true });

      photo.addEventListener('error', () => {
        avatar.dataset.reviewAvatar = 'failed';
      }, { once: true });

      // the merchant's own uploads keep a normal src and are already on their way
      if (photo.dataset.src) {
        photo.src = photo.dataset.src;
        delete photo.dataset.src;
      }
    };

    const watcher = typeof IntersectionObserver === 'undefined'
      ? null
      : new IntersectionObserver((entries, self) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            self.unobserve(entry.target);
            settle(entry.target);
          }
        }, { rootMargin: '200px' });

    const scan = (root) => root.querySelectorAll('[data-review-avatar=""]').forEach((avatar) => {
      if (watcher) watcher.observe(avatar);
      else settle(avatar);
    });

    scan(document);
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* the header is only as tall as its content (a logo image can push it past the
     4.5rem min-height), so publish the measured height for anything that sticks
     or sizes itself under it */
  const headerSection = document.querySelector('.shopify-section:has(> .header)');

  if (headerSection) {
    new ResizeObserver(([entry]) => {
      document.documentElement.style.setProperty('--header-height', `${entry.target.offsetHeight}px`);
    }).observe(headerSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-carousel"] && !Shopify.designMode) return;
  try {
    
  /**
   * <social-oembed> — fills a tile that has no merchant-uploaded cover by asking
   * TikTok's public oEmbed endpoint for the post thumbnail.
   *
   * The endpoint needs no key and sends `access-control-allow-origin: *`, but the
   * thumbnail URL it returns is signed and expires in about 48 hours, so it can't
   * be cached anywhere and has to be fetched on every page load. That's why this
   * runs only when the tile scrolls into view, and why an uploaded cover is still
   * the better path: it stays inside Shopify's responsive image pipeline and costs
   * no third-party request.
   *
   * Every failure mode is silent: the tinted placeholder stays and the tile still
   * links out to the post.
   */
  if (!customElements.get('social-oembed')) {
    class SocialOembed extends HTMLElement {
      connectedCallback() {
        if (this.dataset.url == null || this.dataset.loaded) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '200px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      async load() {
        this.dataset.loaded = 'true';

        try {
          const endpoint = `https://www.tiktok.com/oembed?url=${encodeURIComponent(this.dataset.url)}`;
          const response = await fetch(endpoint);
          if (!response.ok) return;

          const { thumbnail_url: thumbnail } = await response.json();
          // third-party payload: only ever accept an https image URL from it
          if (typeof thumbnail !== 'string' || !thumbnail.startsWith('https://')) return;

          const image = document.createElement('img');
          image.className = 'social-carousel__image';
          image.alt = '';
          image.loading = 'lazy';
          image.src = thumbnail;
          this.replaceChildren(image);
        } catch (error) {
          // offline, blocked by a content blocker, or TikTok rate-limiting us
        }
      }
    }

    customElements.define('social-oembed', SocialOembed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  if (!customElements.get('wishlist-page')) {
    class WishlistPage extends HTMLElement {
      connectedCallback() {
        this.store = window.CitrusWishlist;
        this.grid = this.querySelector('[data-wishlist-grid]');
        if (!this.store || !this.grid) return;

        this.emptyState = this.querySelector('[data-wishlist-empty]');
        this.toolbar = this.querySelector('[data-wishlist-toolbar]');
        this.summary = this.querySelector('[data-wishlist-summary]');
        this.sharedBanner = this.querySelector('[data-wishlist-shared]');
        this.notice = this.querySelector('[data-wishlist-notice]');
        this.noticeText = this.querySelector('[data-wishlist-notice-text]');
        this.undoButton = this.querySelector('[data-wishlist-undo]');
        this.slotTemplate = this.querySelector('[data-wishlist-slot]');
        this.missingTemplate = this.querySelector('[data-wishlist-missing]');

        // last-write-wins: a re-render must not be overwritten by the tiles of
        // the render before it
        this.requestId = 0;
        this.pendingUndo = null;
        this.clearArmed = false;

        const shared = this.store.decode(new URLSearchParams(window.location.search).get('list'));
        this.sharedItems = shared;
        this.shared = shared.length > 0;

        this.onStoreChange = (event) => {
          // our own writes are already reflected in the DOM; only another tab
          // justifies refetching every tile
          if (event.detail && event.detail.action === 'sync' && !this.shared) this.render();
        };
        document.addEventListener(this.store.EVENT, this.onStoreChange);

        this.bind();
        this.render();
      }

      disconnectedCallback() {
        if (this.onStoreChange) document.removeEventListener(this.store.EVENT, this.onStoreChange);
        clearTimeout(this.undoTimer);
        clearTimeout(this.clearTimer);
      }

      bind() {
        this.grid.addEventListener('click', (event) => {
          const button = event.target.closest('[data-wishlist-remove]');
          if (button) this.removeItem(button);
        });

        this.querySelector('[data-wishlist-clear]')?.addEventListener('click', (event) => {
          this.clearList(event.currentTarget);
        });

        this.querySelector('[data-wishlist-share]')?.addEventListener('click', () => this.share());
        this.querySelector('[data-wishlist-save]')?.addEventListener('click', () => this.saveShared());
        this.undoButton?.addEventListener('click', () => this.undo());

        // The sharer link ships hidden so it can never dead-end. On a phone the
        // Facebook app claims that URL and opens on nothing; we only take the
        // link away where the native sheet is there to replace it, so a browser
        // without one keeps its only route to Facebook.
        const facebook = this.querySelector('[data-wishlist-share-facebook]');
        const touch = window.matchMedia('(pointer: coarse)').matches;
        if (facebook && !(touch && navigator.share)) facebook.hidden = false;
      }

      /* ---------- rendering ---------- */

      render() {
        const items = this.shared ? this.sharedItems : this.store.read();
        this.classList.toggle('is-shared', this.shared);
        if (this.sharedBanner) this.sharedBanner.hidden = !this.shared;
        this.syncChrome(items.length);
        this.fill(items);
      }

      /** Counters and the empty state, without touching the tiles. */
      syncChrome(total) {
        const hasItems = total > 0;
        this.grid.hidden = !hasItems;
        if (this.summary) {
          this.summary.hidden = !hasItems;
          this.summary.textContent = this.countLabel(total);
        }
        if (this.emptyState) this.emptyState.hidden = hasItems || this.shared;
        if (this.toolbar) this.toolbar.hidden = !hasItems || this.shared;
        if (!this.shared) this.refreshShareLinks();
      }

      countLabel(total) {
        if (total === 1) return this.dataset.labelCountOne || '';
        return (this.dataset.labelCountOther || '').replace('@@', total);
      }

      async fill(items) {
        const requestId = ++this.requestId;
        this.grid.replaceChildren(...items.map((entry) => this.buildSlot(entry)));
        if (!items.length) return;

        const slots = Array.from(this.grid.children);
        const queue = items.map((entry, index) => ({ entry, slot: slots[index] }));
        // a 50-item list must not fire 50 requests at once
        const workers = Array.from({ length: Math.min(6, queue.length) }, () =>
          this.drain(queue, requestId)
        );
        await Promise.all(workers);
      }

      async drain(queue, requestId) {
        while (queue.length) {
          if (requestId !== this.requestId) return;
          const job = queue.shift();
          const html = await this.fetchItem(job.entry);
          if (requestId !== this.requestId) return;
          this.paint(job.slot, html);
        }
      }

      buildSlot(entry) {
        const slot = this.slotTemplate.content.firstElementChild.cloneNode(true);
        slot.dataset.wishlistKey = this.store.key(entry.h, entry.i);
        slot.dataset.handle = entry.h;
        slot.dataset.variantId = entry.i;
        slot.dataset.savedAt = entry.t;
        return slot;
      }

      async fetchItem(entry) {
        const root = this.dataset.rootUrl || '/';
        const base = root.endsWith('/') ? root.slice(0, -1) : root;
        const url =
          base +
          '/products/' +
          encodeURIComponent(entry.h) +
          '?section_id=wishlist-item&variant=' +
          encodeURIComponent(entry.i);

        try {
          const response = await fetch(url);
          if (!response.ok) return null;
          return await response.text();
        } catch {
          return null;
        }
      }

      paint(slot, html) {
        let tile = null;
        if (html) {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          tile = parsed.querySelector('[data-wishlist-item]');
        }
        // a deleted or unpublished product still deserves a way out of the list
        if (!tile) tile = this.missingTemplate.content.firstElementChild.cloneNode(true);
        if (this.shared) {
          tile.querySelectorAll('[data-wishlist-remove]').forEach((button) => button.remove());
        }
        slot.replaceChildren(tile);
      }

      /* ---------- actions ---------- */

      removeItem(button) {
        const slot = button.closest('[data-wishlist-key]');
        if (!slot) return;

        const entry = {
          h: slot.dataset.handle,
          i: slot.dataset.variantId,
          t: Number(slot.dataset.savedAt) || Date.now(),
        };
        const index = Array.from(this.grid.children).indexOf(slot);

        this.store.remove(entry.h, entry.i);
        slot.remove();
        this.syncChrome(this.store.count());

        // removing by mistake is easy on touch, so the tile is only parked
        this.pendingUndo = { entry, slot, index };
        this.showNotice(this.dataset.labelRemoved, true);
        clearTimeout(this.undoTimer);
        this.undoTimer = setTimeout(() => this.hideNotice(), 6000);
      }

      undo() {
        if (!this.pendingUndo) return;
        const { entry, slot, index } = this.pendingUndo;
        // merge keeps the original timestamp, so the tile returns to its place
        this.store.merge([entry]);

        const siblings = Array.from(this.grid.children);
        if (index >= siblings.length) this.grid.appendChild(slot);
        else this.grid.insertBefore(slot, siblings[index]);

        this.pendingUndo = null;
        this.hideNotice();
        this.syncChrome(this.store.count());
      }

      clearList(button) {
        if (!this.clearArmed) {
          this.clearArmed = true;
          this.clearLabel = button.textContent;
          button.textContent = this.dataset.labelClearConfirm;
          button.classList.add('is-armed');
          clearTimeout(this.clearTimer);
          this.clearTimer = setTimeout(() => this.disarmClear(button), 5000);
          return;
        }

        this.disarmClear(button);
        this.store.clear();
        this.grid.replaceChildren();
        // a pending undo would otherwise wipe the confirmation a moment later
        clearTimeout(this.undoTimer);
        this.pendingUndo = null;
        this.syncChrome(0);
        this.showNotice(this.dataset.labelCleared, false);
      }

      disarmClear(button) {
        clearTimeout(this.clearTimer);
        this.clearArmed = false;
        if (this.clearLabel) button.textContent = this.clearLabel;
        button.classList.remove('is-armed');
      }

      /* ---------- sharing ---------- */

      /**
       * `?list=handle:variantId,…`. Handles and ids are already URL-safe (the
       * store rejects anything else), so they stay readable in the link.
       */
      shareUrl() {
        const base = this.dataset.shareUrl || window.location.origin + window.location.pathname;
        let items = this.store.read();
        let encoded = this.store.encode(items);
        this.truncatedTo = 0;

        while (encoded.length > 1800 && items.length > 1) {
          items = items.slice(0, -1);
          encoded = this.store.encode(items);
          this.truncatedTo = items.length;
        }

        return base + '?list=' + encoded;
      }

      refreshShareLinks() {
        const url = this.shareUrl();
        const message = (this.dataset.shareText || '') + ' ' + url;

        const whatsapp = this.querySelector('[data-wishlist-share-whatsapp]');
        if (whatsapp) whatsapp.href = 'https://wa.me/?text=' + encodeURIComponent(message);

        const mail = this.querySelector('[data-wishlist-share-mail]');
        if (mail) {
          mail.href =
            'mailto:?subject=' +
            encodeURIComponent(this.dataset.shareSubject || '') +
            '&body=' +
            encodeURIComponent(message);
        }

        const facebook = this.querySelector('[data-wishlist-share-facebook]');
        if (facebook) {
          facebook.href =
            'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
        }
      }

      async share() {
        const url = this.shareUrl();
        if (this.truncatedTo) {
          this.showNotice((this.dataset.labelTruncated || '').replace('@@', this.truncatedTo), false);
        }

        if (navigator.share) {
          try {
            await navigator.share({
              title: this.dataset.shareTitle,
              text: this.dataset.shareText,
              url,
            });
          } catch {
            // the customer dismissed the share sheet: nothing to report
          }
          return;
        }

        try {
          await navigator.clipboard.writeText(url);
          this.showNotice(this.dataset.labelCopied, false);
        } catch {
          this.showNotice(this.dataset.labelCopyError, false);
        }
      }

      saveShared() {
        const added = this.store.merge(this.sharedItems);
        let message = this.dataset.labelSavedNone;
        if (added === 1) message = this.dataset.labelSavedOne;
        else if (added > 1) message = (this.dataset.labelSavedOther || '').replace('@@', added);

        // drop ?list= so a reload shows the visitor's own list from now on
        window.history.replaceState({}, '', window.location.pathname);
        this.shared = false;
        this.sharedItems = [];
        this.render();
        this.showNotice(message, false);
      }

      /* ---------- notice ---------- */

      showNotice(text, withUndo) {
        if (!this.notice) return;
        this.noticeText.textContent = text || '';
        this.undoButton.hidden = !withUndo;
        this.notice.classList.toggle('is-visible', Boolean(text));
      }

      hideNotice() {
        if (!this.notice) return;
        this.pendingUndo = null;
        this.noticeText.textContent = '';
        this.undoButton.hidden = true;
        this.notice.classList.remove('is-visible');
      }
    }

    customElements.define('wishlist-page', WishlistPage);
  }

  } catch(e) { console.error(e); }
})();
})();
